import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { capturerMotifRefus } from './app/core/acces-refuse';

// AVANT le bootstrap : seule lecture du motif qui ne dépende d'aucune navigation (cf. acces-refuse.ts).
capturerMotifRefus();

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.name,
    release: environment.release,
    sendDefaultPii: false, // RGPD : pas d'IP / cookies / headers auto
    tracesSampleRate: environment.production ? 0.2 : 1.0,
    tracePropagationTargets: [/\/api\//],
    maxBreadcrumbs: 100,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),
      Sentry.replayIntegration({ maskAllText: true, maskAllInputs: true, blockAllMedia: true }),
    ],
    replaysSessionSampleRate: 0, // pas de replay permanent (RGPD)
    replaysOnErrorSampleRate: environment.production ? 1.0 : 0, // replays UNIQUEMENT en prod
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
